import React from "react";
import Training from "../../images/trainingCard.svg";
import Talks from "../../images/talksCard.svg";
import Team from "../../images/teamCard.svg"
import {
  ServicesContainer,
  ServicesH1,
  ServicesWrapper,
  FeaturedCard,
  ServicesIcon,
  ServicesH2,
  ServicesButton,
  TopPurpleBanner,
} from "./ServicesElements";

const Services = ({ isFilterActive }) => {
  return (
    <ServicesContainer isFilterActive={isFilterActive} id="services">
      <TopPurpleBanner><ServicesH1>HOW</ServicesH1></TopPurpleBanner>
      <ServicesWrapper>
        <FeaturedCard>
          <ServicesIcon src={Team} alt="Illustration of two students at desks with tutor at a white board."/>
          <ServicesH2>TRAINING</ServicesH2>
          <ServicesButton to="/training">Lean More</ServicesButton>
        </FeaturedCard>
        <FeaturedCard>
          <ServicesIcon src={Training} alt="Illustration of three people as with laptops having a discussion."/>
          <ServicesH2>TRIALS</ServicesH2>
          <ServicesButton to="/tech">Lean More</ServicesButton>
        </FeaturedCard>
        <FeaturedCard>
          <ServicesIcon src={Talks} alt="Illustration of three people holding square speech bubbles."/>
          <ServicesH2>TALKS</ServicesH2>
          <ServicesButton to="/talks">Lean More</ServicesButton>
        </FeaturedCard>
        {/* <ServicesCard>
          <ServicesIcon src={FNews} alt="Illustration of a hand holding a phone taking a selfie."/>
          <ServicesH2>Fake News</ServicesH2>
          <ServicesButton to="/fakenews">Lean More</ServicesButton>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={SpecialP} alt="Illustration of person looking at three information cards in the air."/>
          <ServicesH2>Special Projects</ServicesH2>
          <ServicesButton to="/projects">Lean More</ServicesButton>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Meditation} alt="Illustration of person holding a phone with a confirmation tick on the screen."/>
          <ServicesH2 >Meditation</ServicesH2>
          <ServicesButton to="/meditation">Lean More</ServicesButton>
        </ServicesCard> */}
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;
